export default __webpack_public_path__ + "static/media/menu-icon-white.709a0501.svg";